const rankMatrix = {
  'RMA': {
    'F-6': 'MotC',
    'F-5' : 'FMSHL',
    'F-4' : 'GEN',
    'F-3' : 'LTGEN',
    'F-2' : 'MAJGEN',
    'F-1' : 'BRGEN',
    'O-6' : 'COL',
    'O-5' : 'LTCOL',
    'O-4' : 'MAJ',
    'O-3' : 'CPT',
    'O-2' : '1LT',
    'O-1' : '2LT',
    'W-5' : 'MCWO',
    'W-4' : 'SCWO',
    'W-3' : 'CWO',
    'W-2' : 'WO1',
    'W-1' : 'WO2',
    'E-10' : 'CSGTMAJ',
    'E-9' : 'STGMAJ',
    'E-8' : '1SGT',
    'E-7' : 'MSGT',
    'E-6' : 'SSGT',
    'E-5' : 'PSGT',
    'E-4' : 'CPL',
    'E-3' : 'LCPL',
    'E-2' : 'PFC',
    'E-1' : 'PVT'
  },
  'CIVINT': {
    'C-1': 'Civiliian',
    'C-2': 'Analyst',
    'C-3': 'Senior Analyst',
    'C-4': 'Administrative Specialist',
    'C-5': 'Administrator',
    'C-6': 'Senior Administrator',
    'C-7': 'Probationary Special Agent',
    'C-8': 'Special Agent',
    'C-9': 'Foreign Service Officer',
    'C-10': 'Section Chief',
    'C-11': 'Consulate Intelligence Liaison',
    'C-12': 'Senior Special Agent',
    'C-13': 'Senior Principal Officer',
    'C-14': 'Chief of Station',
    'C-15': 'Embassy Intelligence Liaison',
    'C-16': 'Embassy Senior Intelligence Liaison',
    'C-17': 'Zone Chief',
    'C-18': 'Sector Chief',
    'C-19': 'Regional Director',
    'C-20': 'Deputy Director of Operations',
    'C-21': 'Deputy Director of Intelligence',
    'C-22': 'Director of Intelligence',
    'C-23': 'Home Secretary'
  },
  'CIVDIP': {
    'C-1': 'Civiliian',
    'C-2': 'Clerk',
    'C-3': 'Senior Clerk',
    'C-4': 'Administrative Specialist',
    'C-5': 'Administrator',
    'C-6': 'Senior Administrator',
    'C-7': 'Consular Staff',
    'C-8': 'Consular Agent',
    'C-9': 'Embassy Staff',
    'C-10': 'Section Chief',
    'C-11': 'Consular Attache',
    'C-12': 'Vice-Consul',
    'C-13': 'Special Envoy',
    'C-14': 'Consul',
    'C-15': 'Embassy Attache',
    'C-16': 'Embassy Senior Attache',
    'C-17': 'Consul General',
    'C-18': 'Minister Resident',
    'C-19': 'Envoy Extraordinary and Plenipotentiary',
    'C-20': 'Charge d\'Affairs',
    'C-21': 'Ambassador Extraordianry and Plenipotentiary',
    'C-22': 'Foreign Minister',
    'C-23': 'Home Secretary'
  },
  'SFC': {
    'C-1': 'Cadet Ranger One',
    'C-2': 'Cadet Ranger Two',
    'C-3': 'Cadet Ranger Three',
    'C-6': 'Senior Cadet Ranger',
    'C-7': 'Ranger',
    'C-9': 'Ranger Corporal',
    'C-10': 'Ranger Sergeant',
    'C-13': 'Ranger Lieutenant',
    'C-14': 'Ranger Captain',
    'C-15': 'Ranger Major',
    'C-16': 'Ranger Lieutenant Colonel',
    'C-17': 'Ranger Colonel',
    'C-18': 'Station Chief Ranger',
    'C-19': 'Sector Chief Ranger',
    'C-20': 'Planetary Chief Ranger',
    'C-21': 'Head Ranger',
    'C-22': 'Commissioner',
    'C-23': 'Home Secretary'
  },
  'RMACS': {
    'C-1': 'Trainee',
    'C-4': 'PO3',
    'C-5': 'PO2',
    'C-6': 'PO1',
    'C-7': 'CPO',
    'C-8': 'SCPO',
    'C-9': 'MCPO',
    'C-12': 'ENS',
    'C-13': 'LTJG',
    'C-14': 'LTSG',
    'C-15': 'LCDR',
    'C-16': 'CDR',
    'C-17': 'CAPT',
    'C-18': 'CDRE',
    'C-19': 'RADM',
    'C-20': 'VADM',
    'C-21': 'ADM',
    'C-22': 'Transport Minister',
    'C-23': 'Home Secreatary'
  },
  'RMMM': {
    'C-1': 'Apprentice Spacer',
    'C-2': 'Spacer II',
    'C-3': 'Spacer III',
    'C-6': 'Spacer IV',
    'C-7': 'Spacer V',
    'C-8': 'Spacer VI',
    'C-12': 'Fourth Officer',
    'C-18': 'Fleet Manager',
    'C-19': 'Superintendent',
    'C-20': 'Managing Director',
    'C-21': 'Trade Minister',
    'C-22': 'Transport Minister',
    'C-23': 'Home Secretary'
  },
  'RMMME': {
    'C-2': 'Wiper',
    'C-3': 'Technician III',
    'C-6': 'Technician IV',
    'C-7': 'Technician V',
    'C-8': 'Technician VI',
    'C-12': 'Fourth Engineer',
    'C-13': 'Third Enginner',
    'C-15': 'Second Engineer',
    'C-16': 'First Engineer',
    'C-17': 'Chief Engineer',
    'C-18': 'Fleet Port Manager',
    'C-19': 'Superintendent',
    'C-20': 'Managing Director',
    'C-21': 'Trade Minister',
    'C-22': 'Transport Minister',
    'C-23': 'Home Secretary'
  },
  'RMMMM': {
    'C-6': 'Sick Berth Attendant',
    'C-8': 'Senior Sick Berth Attendant',
    'C-12': 'Nurse',
    'C-13': 'Senior Nurse',
    'C-15': 'Assistant Merchant Surgeon',
    'C-16': 'Merchant Surgeon',
    'C-18': 'Fleet Medical Director',
    'C-19': 'Superintendent',
    'C-20': 'Managing Director',
    'C-21': 'Trade Minister',
    'C-22': 'Transport Minister',
    'C-23': 'Home Secretary'
  },
  'RMMMC': {
    'C-2': 'Assistant',
    'C-3': 'Pantry Assistant',
    'C-4': 'Baker',
    'C-5': 'Chief Cook',
    'C-6': 'Chief Steward',
    'C-12': 'Junior Purser',
    'C-13': 'Purser',
    'C-15': 'Assistant Cruise Director',
    'C-16': 'Cruise Director',
    'C-18': 'Fleet Passenger Director',
    'C-19': 'Superintendent',
    'C-20': 'Managing Director',
    'C-21': 'Trade Minister',
    'C-22': 'Transport Minister',
    'C-23': 'Home Secretary'
  },
  'RMMMD': {
    'C-2': 'Ordinary Spacer',
    'C-3': 'Efficient Spacer',
    'C-6': 'Able Spacer',
    'C-7': 'Leading Spacer',
    'C-8': 'Certified Bosun',
    'C-12': 'Fourth Officer',
    'C-13': 'Third Officer',
    'C-15': 'Second Officer',
    'C-16': 'First Officer',
    'C-17': 'Master',
    'C-18': 'Fleet Manager',
    'C-19': 'Superintendent',
    'C-20': 'Managing Director',
    'C-21': 'Trade Minister',
    'C-22': 'Transport Minister',
    'C-23': 'Home Secretary'
  },
  'RMN': {
    'F-5': 'FADM',
    'F-4-A': 'ADM',
    'F-4-B': 'ADM',
    'F-3-A': 'VADM',
    'F-3-B': 'VADM',
    'F-2-A': 'RADM',
    'F-2-B': 'RADM',
    'F-1': 'CDRE',
    'O-6-B': 'CAPTSG',
    'O-6-A': 'CAPTJG',
    'O-5': 'CDR',
    'O-4': 'LCDR',
    'O-3': 'LTSG',
    'O-2': 'LTJG',
    'O-1': 'ENS',
    'W-5': 'MCWO',
    'W-4': 'SCWO',
    'W-3': 'CWO',
    'W-2': 'WO1',
    'W-1': 'WO2',
    'E-10': 'SMCPO',
    'E-9': 'MCPO',
    'E-8': 'SCPO',
    'E-7': 'CPO',
    'E-6': 'PO1',
    'E-5': 'PO2',
    'E-4': 'PO3',
    'E-3': 'S1C',
    'E-2': 'S2C',
    'E-1': 'S3C'
  },
  'GSN': {
    'F-5': 'HADM',
    'F-4': 'ADM',
    'F-3': 'VADM',
    'F-2': 'RADM',
    'F-1': 'CDRE',
    'O-6': 'CAPT',
    'O-5': 'CDR',
    'O-4': 'LCDR',
    'O-3': 'LTSG',
    'O-2': 'LTJG',
    'O-1': 'ENS',
    'W-5': 'SMCWO',
    'W-4': 'MCWO',
    'W-3': 'SCWO',
    'W-2': 'CWO',
    'W-1': 'WO',
    'E-10': 'SMCPO',
    'E-9': 'MCPO',
    'E-8': 'SCPO',
    'E-7': 'CPO',
    'E-6': 'PO1',
    'E-5': 'PO2',
    'E-4': 'PO3',
    'E-3': 'S1C',
    'E-2': 'S2C',
    'E-1': 'S3C'
  },
  'RHN': {
    'F-5': 'FADM',
    'F-4': 'ADM',
    'F-3': 'VADM',
    'F-2': 'RADM',
    'F-1': 'CDRE',
    'O-6': 'CAPT',
    'O-5': 'CDR',
    'O-4': 'LCDR',
    'O-3': 'LTSG',
    'O-2': 'LTJG',
    'O-1': 'ENS',
    'W-5': 'MCWO',
    'W-4': 'SCWO',
    'W-3': 'CWO',
    'W-2': 'WO1',
    'W-1': 'WO2',
    'E-10': 'SMCPO',
    'E-9': 'MCPO',
    'E-8': 'SCPO',
    'E-7': 'CPO',
    'E-6': 'PO1',
    'E-5': 'PO2',
    'E-4': 'PO3',
    'E-3': 'S1C',
    'E-2': 'S2C',
    'E-1': 'S3C'
  },
  'IAN': {
    'F-5': 'GADM',
    'F-4': 'ADM',
    'F-3': 'VADM',
    'F-2': 'KADM',
    'F-1': 'FADM',
    'O-6': 'KDS',
    'O-5': 'FK',
    'O-4': 'KK',
    'O-3': 'KL',
    'O-2': 'OLDS',
    'O-1': 'LDS',
    'E-10': 'OSBDF',
    'E-9': 'OSB',
    'E-8': 'SB',
    'E-7': 'OB',
    'E-6': 'B',
    'E-5': 'OMT',
    'E-4': 'MT',
    'E-3': 'HGEFR',
    'E-2': 'OGEFR',
    'E-1': 'GEFR'
  },
  'RMMC': {
    'F-6': 'MotC',
    'F-5' : 'FMSHL',
    'F-4' : 'GEN',
    'F-3' : 'LTGEN',
    'F-2' : 'MAJGEN',
    'F-1' : 'BRGEN',
    'O-6' : 'COL',
    'O-5' : 'LTCOL',
    'O-4' : 'MAJ',
    'O-3' : 'CPT',
    'O-2' : '1LT',
    'O-1' : '2LT',
    'W-5' : 'MCWO',
    'W-4' : 'SCWO',
    'W-3' : 'CWO',
    'W-2' : 'WO1',
    'W-1' : 'WO2',
    'E-10' : 'CSGTMAJ',
    'E-9' : 'STGMAJ',
    'E-8' : '1SGT',
    'E-7' : 'MSGT',
    'E-6' : 'SSGT',
    'E-5' : 'PSGT',
    'E-4' : 'CPL',
    'E-3' : 'LCPL',
    'E-2' : 'PFC',
    'E-1' : 'PVT'
  }
}


export { rankMatrix }
